import api from "../../utils/API";

const getAllSearchLists = () =>
    api.get(`/candidatmanagement/recherche/searchlists`);

const advancedSearchIA = (payload) =>
    api.post("/search/advanced", payload);

const resolveCandidatesForIa = (uploadIds = []) =>
    api.post("/candidatsmanagement/candidats/by-upload-ids", { ids: uploadIds });

const agentTextSearch = (text, userId = "") =>
    api.post("/agent/query", { text, user_id: userId });

const sendChatMessage = (message, conversationId) => {
  return api.post("/chat/message", { message, conversation_id: conversationId });
};
const chatMessage = (message, userId = "") =>
    api.post("/chat/message", { message, user_id: userId });

const getTalentBoard = (queryString = "") =>
    api.get(`/candidatmanagement/talent-board${queryString ? `?${queryString}` : ""}`);

export { getAllSearchLists, advancedSearchIA, resolveCandidatesForIa, agentTextSearch, getTalentBoard,sendChatMessage, chatMessage};